import type { BoardDoc } from '../collab/BoardDoc';
import { useCall } from '../call/CallProvider';
import { FollowFace } from '../call/ParticipantTile';
import { usePeers } from '../collab/hooks';
import { useEditor } from '../state/store';
import { Icon } from './icons';

/**
 * Follow-mode indicator.
 *
 * Follow mode takes the camera away from the user, so it needs a permanent,
 * unmissable way out — otherwise the board reads as broken ("why does it keep
 * moving?"). The banner names who is being followed, shows their camera when
 * they are on the call, and states the shortcut.
 */
export function FollowBanner({ doc }: { doc: BoardDoc }) {
  const followingUserId = useEditor((s) => s.followingUserId);
  const peers = usePeers(doc);
  const call = useCall();
  if (!followingUserId) return null;

  const peer = peers.find((p) => p.userId === followingUserId);
  if (!peer) return null;

  const participant = call.participants.find((p) => p.identity === followingUserId) ?? null;

  return (
    <div className="follow-cluster">
      <FollowFace participant={participant} name={peer.name} color={peer.color} />
      <div className="follow-banner" style={{ borderColor: peer.color }} role="status">
        <span className="follow-dot" style={{ background: peer.color }} />
        Следите за <strong>{peer.name}</strong>
        <button
          type="button"
          onClick={() => useEditor.getState().setUi({ followingUserId: null })}
          aria-label="Прекратить слежение"
        >
          <Icon name="close" size={13} />
        </button>
        <kbd>Esc</kbd>
      </div>
    </div>
  );
}
